import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { useApi } from "@/lib/useApi";
import { errMsg, formatDate } from "@/lib/api";
import { PageHeader } from "@/pages/admin/AdminLayout";

export default function AdminUsers() {
  const call = useApi();
  const [data, setData] = useState(null);
  const load = useCallback(() => call("get", "/users").then(setData), [call]);
  useEffect(() => { load(); }, [load]);

  const change = async (uid, role) => {
    try { await call("patch", `/users/${uid}/role`, { role }); toast.success("Peran diperbarui"); load(); }
    catch (e) { toast.error(errMsg(e)); }
  };

  return (
    <div>
      <PageHeader title="Pengguna" />
      <p className="mb-4 text-sm text-stone-600">Pembeli yang membuat akun tampil di sini. Jadikan "admin" untuk memberi akses panel admin.</p>
      <div className="overflow-x-auto rounded-lg border border-stone-200 bg-white">
        <table className="w-full min-w-[560px] text-sm">
          <thead className="bg-stone-100 text-left text-xs text-stone-600"><tr><th className="p-3">Email</th><th className="p-3">Nama</th><th className="p-3">Terdaftar</th><th className="p-3">Peran</th></tr></thead>
          <tbody className="divide-y divide-stone-100">
            {(data?.users || []).map((u) => (
              <tr key={u.user_id} data-testid={`user-row-${u.user_id}`}>
                <td className="p-3">{u.email || u.user_id}</td><td className="p-3">{u.name || "-"}</td><td className="p-3 text-stone-600">{formatDate(u.created_at, false)}</td>
                <td className="p-3">
                  <select value={u.role} onChange={(e) => change(u.user_id, e.target.value)} data-testid={`user-role-select-${u.user_id}`} className="h-8 rounded-md border border-stone-200 bg-white px-2 text-sm">
                    {data.roles.map((r) => <option key={r} value={r}>{r}</option>)}
                  </select>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
